document.addEventListener('DOMContentLoaded', () => {
  const stickyPanel = document.querySelector('sticky-atc-panel');
  if (!stickyPanel) return;

  const stickyBtn = stickyPanel.querySelector('button[name="add"]');
  if (!stickyBtn) return;

  // Helper: find the main add button for the same product section
  function findMainAddBtn() {
    const productEl = stickyPanel.closest('.js-product') || document.querySelector('.js-product');
    return (
      (productEl && productEl.querySelector('.js-product-form-main button[name="add"]')) ||
      (productEl && productEl.querySelector('.product-info__add-button button[name="add"]')) ||
      document.querySelector('.js-product-form-main button[name="add"]') ||
      document.querySelector('.product-info__add-button button[name="add"]')
    );
  }

  // Disable sticky button with light effect
  function disableStickyBtn(btn) {
    if (!btn) return;
    btn.disabled = true;
    btn.classList.add('btn--loading'); // fade/light effect
  }

  // Enable sticky button
  function enableStickyBtn(btn) {
    if (!btn) return;
    btn.disabled = false;
    btn.classList.remove('btn--loading');
  }

  stickyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const mainAddBtn = findMainAddBtn();

    disableStickyBtn(stickyBtn); // disable immediately

    if (!mainAddBtn) {
      const stickyForm = stickyPanel.querySelector('form');
      if (stickyForm) stickyForm.submit();
      return;
    }

    // Copy sticky form values to main form
    const stickyForm = stickyPanel.querySelector('form');
    const mainForm = mainAddBtn.closest('form');
    if (stickyForm && mainForm) {
      const stickyId = stickyForm.querySelector('input[name="id"]')?.value;
      const stickyQty = stickyForm.querySelector('input[name="quantity"]')?.value;

      if (stickyId) {
        let mainIdInput = mainForm.querySelector('input[name="id"]');
        if (!mainIdInput) {
          mainIdInput = document.createElement('input');
          mainIdInput.type = 'hidden';
          mainIdInput.name = 'id';
          mainForm.appendChild(mainIdInput);
        }
        mainIdInput.value = stickyId;
      }

      if (stickyQty) {
        let mainQtyInput = mainForm.querySelector('input[name="quantity"]');
        if (!mainQtyInput) {
          mainQtyInput = document.createElement('input');
          mainQtyInput.type = 'hidden';
          mainQtyInput.name = 'quantity';
          mainForm.appendChild(mainQtyInput);
        }
        mainQtyInput.value = stickyQty;
      }
    }

    // Temporarily enable main button if disabled
    const wasDisabled = mainAddBtn.disabled;
    if (wasDisabled) mainAddBtn.disabled = false;

    mainAddBtn.click(); // trigger main add-to-cart

    if (wasDisabled) mainAddBtn.disabled = true;

    setTimeout(() => {
      stickyBtn.disabled = false;
      stickyBtn.classList.remove('btn--loading');
    }, 2500);
  });

  // Mirror disabled state from main button
  let updating = false;

  const updateStickyDisabledState = () => {
    if (updating) return;
    updating = true;
    const mainAddBtn = findMainAddBtn();
    if (!mainAddBtn) {
      updating = false;
      return;
    }

    // Only update if state differs
    if (stickyBtn.disabled !== mainAddBtn.disabled) {
      stickyBtn.disabled = mainAddBtn.disabled;
    }

    updating = false;
  };

  const observerTarget = stickyPanel.closest('.js-product') || document;
  try {
    const mo = new MutationObserver(updateStickyDisabledState);
    mo.observe(observerTarget, { attributes: true, subtree: true, attributeFilter: ['disabled', 'class'] });
  } catch (err) { /* ignore */ }

  updateStickyDisabledState(); // initial sync
});
